import { ACTIONS, COOKIES, ADDONS } from '../constants';
import { isPackageFree, isPackagePro } from '../utils/displayHelpers';
import { getParsedCookie, setStringifiedCookie } from '../utils/cookieHelpers';

const getInitialState = () => {
  const activePackage = {
    id: '',
    name: 'Trial 40K',
  };
  const parsedCookie = getParsedCookie(COOKIES.SELECTED_PACKAGES);
  if (parsedCookie && parsedCookie.packages) {
    activePackage.id = parsedCookie.packages.default ? parsedCookie.packages.default : '';
  }
  return {
    availablePackages: [],
    activePackage,
    activeIsFree: isPackageFree(activePackage.id),
    packagesLoaded: false,
  };
};

const packages = (state = getInitialState(), action) => {
  switch (action.type) {
    case ACTIONS.LOAD_PACKAGES: {
      const activePackage =
        action.availablePackages.find(pkg => pkg.id === state.activePackage.id) ||
        action.availablePackages.find(pkg => pkg.base_price === 0); // default to free if no preset
      return {
        ...state,
        availablePackages: action.availablePackages,
        packagesLoaded: true,
        activePackage: activePackage || state.activePackage,
        activeIsFree: activePackage ? isPackageFree(activePackage.id) : true,
      };
    }
    case ACTIONS.SET_PACKAGE: {
      // update cookie
      const parsedCookie = getParsedCookie(COOKIES.SELECTED_PACKAGES);
      parsedCookie.packages = { default: action.activePackage ? action.activePackage.id : '' };
      if (
        !isPackagePro(action.activePackage.id) &&
        parsedCookie.addons &&
        parsedCookie.addons[ADDONS.DEDICATED_IP] &&
        parsedCookie.addons[ADDONS.DEDICATED_IP] > 0
      ) {
        parsedCookie.addons[ADDONS.DEDICATED_IP] = 0;
      }
      setStringifiedCookie(COOKIES.SELECTED_PACKAGES, parsedCookie);
      const setActivePackage =
        state.availablePackages.find(pkg => pkg.id === action.activePackage.id) ||
        action.activePackage;

      return {
        ...state,
        activePackage: setActivePackage || {},
        activeIsFree: setActivePackage ? isPackageFree(setActivePackage.id) : true,
      };
    }
    default:
      return state;
  }
};

export default packages;



// WEBPACK FOOTER //
// ./src/reducers/packages.js